export default __webpack_public_path__ + "static/media/File No. 18.351099cd.pdf";